<template>
  <div id="app">
    <b-alert show>404</b-alert>
  </div>
</template>

<script>

export default {
  name: '404',
}
</script>

<style>

</style>
